import * as React from 'react'
import styled from 'styled-components'

import { ArticleCard, ButtonAsLink, LineGridLayout, breakpoint, styles as S } from '@bob/design-system'
import * as entity from '@boutique/entities'
import * as url from '@bob/url'

type SimilarProps = {
  article: entity.article.Article
}

export function Similar({ article }: SimilarProps): React.ReactElement {
  if (article.similar.length === 0) return <></>
  return (
    <Section>
      {/* RESPONSIVE: Title2 on mobile --- Title4 on desktop  */}
      <S.heading.Title2>Ces articles pourraient vous plaire...</S.heading.Title2>
      <S.heading.Title4>Ces articles pourraient vous plaire...</S.heading.Title4>
      <LineGridLayout>
        {article.similar.map((similar) => (
          <ArticleCard
            key={similar.slug}
            href={url.article({ slug: similar.slug, title: similar.title }).path}
            tag={similar.section}
            title={similar.title}
            date={new Date(similar.firstPublishedAt ?? '').toLocaleDateString('fr-FR', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            })}
            image={similar.image}
          />
        ))}
      </LineGridLayout>
      <ButtonAsLink href={url.articles().path}>Voir tous les articles</ButtonAsLink>
    </Section>
  )
}

const Section = styled.section`
  margin-bottom: 60px;

  ${S.heading.Title2} {
    display: none;
  }

  @media screen and (${breakpoint.TABLET}) {
    margin-bottom: 80px;
    width: auto;
    display: flex;
    flex-direction: column;

    ${S.heading.Title2} {
      display: inline-block;
    }

    ${S.heading.Title4} {
      display: none;
    }
  }

  ${LineGridLayout} {
    margin-bottom: 30px;
    margin-top: 30px;
  }

  ${ButtonAsLink} {
    width: 100%;

    @media screen and (${breakpoint.TABLET}) {
      width: auto;
      padding-left: 10%;
      padding-right: 10%;
      display: inline-flex;
      margin: 0px auto;
    }
  }
`
